import { CRM_SOURCE_OPTIONS } from '../../constants/sourceOptions.ts';

export interface AuthCtx {
  clientId: number;
  effectiveClientId: number;
  clinicId: number;
}

export const getAuth = (clinicIdProp?: number): AuthCtx => {
  const userType = localStorage.getItem('user_type');
  const clientId = parseInt(localStorage.getItem('client_id') || '0', 10);
  const effectiveClientId =
    userType === 'user'
      ? parseInt(localStorage.getItem('master_client_id') || '0', 10)
      : clientId;
  const clinicId = clinicIdProp ?? parseInt(localStorage.getItem('clinic_id') || '0', 10);
  return { clientId, effectiveClientId, clinicId };
};

export const maskCurrencyBRL = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  const numericValue = parseFloat(digits) / 100;
  return numericValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const parseBRLToNumber = (value: string): number => {
  if (!value) return 0;
  const cleaned = value.replace(/[^\d,]/g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
};

export const nowDateInputs = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const HH = String(now.getHours()).padStart(2, '0');
  const MM = String(now.getMinutes()).padStart(2, '0');
  return { date: `${yyyy}-${mm}-${dd}`, time: `${HH}:${MM}` };
};

export const toBRDateTimeString = (date: string, time: string): string => {
  const [yyyy, mm, dd] = date.split('-');
  const [HH, MM] = time.split(':');
  return `${dd}/${mm}/${yyyy} ${HH}:${MM}`;
};

export const toISOSimpleString = (date: string, time: string): string => {
  return `${date}T${time}:00`;
};

export const extractDateTimeInputs = (raw?: string): { date: string; time: string } | null => {
  if (!raw) return null;
  // Tenta ISO
  const d = new Date(raw.replace(' ', 'T'));
  if (!isNaN(d.getTime())) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const HH = String(d.getHours()).padStart(2, '0');
    const MM = String(d.getMinutes()).padStart(2, '0');
    return { date: `${yyyy}-${mm}-${dd}`, time: `${HH}:${MM}` };
  }
  return null;
};

export const SOURCE_OPTIONS = CRM_SOURCE_OPTIONS;
